// GetTimeZonesBR.js
// Mesmo estilo do GetCountries.js: export default [ ... ]

export default [
  {
    "id": "America/Rio_Branco",
    "label": "Acre (UTC−05:00)",
    "abbr": "ACT",
    "utc_offset": "-05:00",
    "example_city": "Rio Branco"
  },
  {
    "id": "America/Manaus",
    "label": "Amazônia (UTC−04:00)",
    "abbr": "AMT",
    "utc_offset": "-04:00",
    "example_city": "Manaus"
  },
  {
    "id": "America/Sao_Paulo",
    "label": "Brasília (UTC−03:00)",
    "abbr": "BRT",
    "utc_offset": "-03:00",
    "example_city": "São Paulo / Brasília"
  },
  {
    "id": "America/Noronha",
    "label": "Fernando de Noronha (UTC−02:00)",
    "abbr": "FNT",
    "utc_offset": "-02:00",
    "example_city": "Fernando de Noronha"
  }
];